module.exports = __webpack_public_path__ + "img/receive.885b6baa.svg";